import { useMemo } from "react";
import { useMediaQuery } from "@mui/material";

/**
 * Per-device default column visibility for react-admin's <DataTable>.
 *
 * Returns the column sources that should be hidden by default when the
 * viewport is phone-width. Feed the result to <DataTable> and add a
 * <ColumnsButton> to the list actions:
 *
 *   const phoneHidden = ["temperature", "redox"];
 *   const hiddenColumns = useDeviceHiddenColumns(phoneHidden);
 *   ...
 *   <DataTable hiddenColumns={hiddenColumns}> ... </DataTable>
 *
 * The defaults only apply until the user toggles columns with the
 * <ColumnsButton>: once the user makes a choice it wins over the
 * device default (kept for the session in react-admin's store, same
 * behaviour as the Datagrid's SelectColumnsButton).
 *
 * @param {string[]} phoneHidden column sources to hide on phones
 * @returns {string[]} column sources to hide at the current viewport
 */
export const useDeviceHiddenColumns = (phoneHidden = []) => {
 const isPhone = useMediaQuery((theme) => theme.breakpoints.down("sm"));
 // Return stable arrays so we don't churn the <DataTable> store context
 // on every render (react-admin's useStore compares by value anyway).
 return useMemo(() => (isPhone ? phoneHidden : []), [isPhone, phoneHidden]);
};
